/**
 * Whether a request failed because the route does not exist, rather than because
 * the request went wrong.
 *
 * **Why this matters enough to be shared.** Several admin surfaces are built
 * against endpoints that have not shipped, and a 404 renders identically to an
 * empty result if nothing distinguishes them — a column of em dashes and a chart
 * of nothing. But "we have not built this" and "this merchant has stopped
 * trading" are opposite facts, and an admin acting on the second when it was the
 * first chases someone who is fine.
 *
 * Lives in `shared` because it is a pure predicate over an axios error shape
 * with no domain knowledge at all. It was briefly duplicated in
 * `entities/store` and `entities/analytics`, which collided on the barrel
 * re-export in `entities/index.ts` — the collision was the signal that it had no
 * business in either slice.
 *
 * 501 counts too: an endpoint stubbed but not implemented is the same fact for
 * the reader.
 */
export function isRouteMissing(error: unknown): boolean {
  const status = (error as { response?: { status?: number } })?.response?.status;
  return status === 404 || status === 501;
}
